import {
  BodyText,
  Box,
  Flex,
  Heading,
  IconContainer,
  Link,
} from '@utilitywarehouse/hearth-react';
import {
  CashbackCardSmallIcon,
  ChevronRightSmallIcon,
} from '@utilitywarehouse/hearth-react-icons';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';

import { paths } from '@constants/paths';

import { TierRoundel } from './TierRoundel';

interface ClaimStepProps {
  cashbackCardAdded: boolean;
}

const ClaimStep = ({ cashbackCardAdded }: ClaimStepProps) => {
  const navigate = useNavigate();

  return (
    <Flex direction="column" gap="150" width="100%" paddingTop="50">
      <Heading as="h4" size="sm">
        {cashbackCardAdded
          ? 'Enjoy your welcome bonus!'
          : 'One step left to claim your bonus'}
      </Heading>
      <Flex gap="100" alignItems="center" width="100%">
        <TierRoundel reached={cashbackCardAdded} />
        <Box flex="1" minWidth="0">
          <BodyText
            size="sm"
            weight={cashbackCardAdded ? 'semibold' : 'regular'}
          >
            {cashbackCardAdded
              ? 'Cashback card added'
              : 'Add Cashback card to your bundle'}
          </BodyText>
        </Box>
        <Flex
          className={clsx({ welcomeBonus__dashed: !cashbackCardAdded })}
          borderWidth="1"
          borderColor="strong"
          borderRadius="md"
          overflow="clip"
          flexShrink="0"
        >
          <IconContainer colorScheme="cashback" size="sm">
            <CashbackCardSmallIcon />
          </IconContainer>
        </Flex>
      </Flex>
      {!cashbackCardAdded && (
        <Link asChild>
          <button type="button" onClick={() => navigate(paths.cashback)}>
            Find out more
            <ChevronRightSmallIcon />
          </button>
        </Link>
      )}
    </Flex>
  );
};

export { ClaimStep };
